export function cookiesInit() {
  $('.cookies-accept').on('click', () => {
    /*todo действия при принятии cookies*/
    cookiesClose();
  });

  $('.cookies-close').on('click', () => {
    cookiesClose();
  });
}

export function cookiesClose() {
  $('.cookies').fadeOut(300);
}
